import { STRINGS } from '@/constants/strings';
import { ComponentScreen } from '@/features/development/screens/component-screen';
import { DevelopmentScreen } from '@/features/development/screens/development-screen';
import type { DevelopmentStackParamList } from '@/navigations/types';
import { createNativeStackNavigator } from '@react-navigation/native-stack';
import React from 'react';

const Stack = createNativeStackNavigator<DevelopmentStackParamList>();

export function DevelopmentStack() {
  return (
    <Stack.Navigator
      initialRouteName="Development"
      screenOptions={{
        headerShown: false,
        animation: 'slide_from_right',
        title: STRINGS.appDocumentTitle,
      }}>
      <Stack.Screen name="Development" component={DevelopmentScreen} />
      <Stack.Screen name="Component" component={ComponentScreen} />
    </Stack.Navigator>
  );
}
